module.exports = __webpack_public_path__ + "src/assets/img/speedo-ico.95ed5f22.png";